module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [(_vm.step === _vm.currentStep) ? _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        return _vm.productAcivateUpdateFlag('details')
      }
    }
  }, [_c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('avatar-uploader', {
    attrs: {
      "value": _vm.currentImage,
      "originalImage": _vm.originalForm && (_vm.originalForm.imageLogoBase64 || _vm.originalForm.imageLogo),
      "showPreview": false,
      "showButton": true,
      "showRequirements": true,
      "requirementsHorizontal": true,
      "backgroundCard": true,
      "buttonType": 'picture',
      "isSizeOk": _vm.avatarRequirements.isSizeOk,
      "isFormatOk": _vm.avatarRequirements.isFormatOk,
      "image": _vm.form.imageLogo,
      "imageBase64": _vm.form.imageLogoBase64,
      "imageHash": _vm.form.imageLogoHash,
      "originalImageSync": _vm.originalForm.imageLogo,
      "originalImageBase64Sync": _vm.originalForm.imageLogoBase64,
      "originalHashSync": _vm.originalForm.imageLogoHash
    },
    on: {
      "update:isSizeOk": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isSizeOk", $event)
      },
      "update:is-size-ok": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isSizeOk", $event)
      },
      "update:isFormatOk": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isFormatOk", $event)
      },
      "update:is-format-ok": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isFormatOk", $event)
      },
      "update:image": function($event) {
        return _vm.$set(_vm.form, "imageLogo", $event)
      },
      "update:imageBase64": function($event) {
        return _vm.$set(_vm.form, "imageLogoBase64", $event)
      },
      "update:image-base64": function($event) {
        return _vm.$set(_vm.form, "imageLogoBase64", $event)
      },
      "update:imageHash": function($event) {
        return _vm.$set(_vm.form, "imageLogoHash", $event)
      },
      "update:image-hash": function($event) {
        return _vm.$set(_vm.form, "imageLogoHash", $event)
      },
      "update:originalImageSync": function($event) {
        return _vm.$set(_vm.originalForm, "imageLogo", $event)
      },
      "update:original-image-sync": function($event) {
        return _vm.$set(_vm.originalForm, "imageLogo", $event)
      },
      "update:originalImageBase64Sync": function($event) {
        return _vm.$set(_vm.originalForm, "imageLogoBase64", $event)
      },
      "update:original-image-base64-sync": function($event) {
        return _vm.$set(_vm.originalForm, "imageLogoBase64", $event)
      },
      "update:originalHashSync": function($event) {
        return _vm.$set(_vm.originalForm, "imageLogoHash", $event)
      },
      "update:original-hash-sync": function($event) {
        return _vm.$set(_vm.originalForm, "imageLogoHash", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel mt-0 shaded radius-top-left-none radius-top-right-none"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    class: {
      error: _vm.$v.form.name.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                                    Product name\n                                                    "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                                                        *\n                                                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }, _vm.$v.form.name.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Name must have at least 3 characters.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.getCategories) ? _c('div', [_vm._m(0), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.categories,
      "multiple": true,
      "taggable": false,
      "track-by": "id",
      "label": "name",
      "selectLabel": "",
      "deselectLabel": ""
    },
    on: {
      "input": _vm.categoriesChanged
    },
    model: {
      value: (_vm.form.categoryList),
      callback: function($$v) {
        _vm.$set(_vm.form, "categoryList", $$v)
      },
      expression: "form.categoryList"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.getEventColors) ? _c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                                    Color\n                                                ")]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "selectedId": _vm.form.color,
      "colors": _vm.getEventColors
    },
    on: {
      "colorChanged": _vm.updateColor
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row my-4"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('checkbox', {
    on: {
      "input": _vm.changePrivateStatus
    },
    model: {
      value: (_vm.form.isPrivate),
      callback: function($$v) {
        _vm.$set(_vm.form, "isPrivate", $$v)
      },
      expression: "form.isPrivate"
    }
  }, [_vm._v("\n                                                    Private tour / Charter.\n                                                    "), _c('span', {
    staticClass: "normal"
  }, [_vm._v("\n                                                        Only one booking per tour is allowed.\n                                                    ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full d-flex align-items-center mb-1"
  }, [_c('span', [_vm._v("Brief description")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'Add a short summary to highlight the key selling points of the experience.<br>It supports agents during search and is visible to customers after booking confirmation.',
        html: true
      }),
      expression: "{\n                                                            content: 'Add a short summary to highlight the key selling points of the experience.<br>It supports agents during search and is visible to customers after booking confirmation.',\n                                                            html: true\n                                                        }"
    }],
    staticClass: "fa fa-info-circle fs-normal dark has-tooltip ml-2"
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.descriptionBrief),
      expression: "form.descriptionBrief"
    }],
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": (_vm.form.descriptionBrief)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "descriptionBrief", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full d-flex align-items-center"
  }, [_c('span', [_vm._v("Product description")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Provide a detailed description to help agents understand and confidently promote your experience'),
      expression: "'Provide a detailed description to help agents understand and confidently promote your experience'"
    }],
    staticClass: "fa fa-info-circle fs-normal dark has-tooltip ml-2"
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    attrs: {
      "rows": "8"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full d-flex align-items-center"
  }, [_c('span', [_vm._v("Ticket information")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'Include important practical details such as terms & conditions, check-in instructions, or other notes.<br>This information will be shown to customers in the T&Cs section of the widget, in the booking confirmation email, and on the ticket.',
        html: true
      }),
      expression: "{ \n                                                            content: 'Include important practical details such as terms & conditions, check-in instructions, or other notes.<br>This information will be shown to customers in the T&Cs section of the widget, in the booking confirmation email, and on the ticket.', \n                                                            html: true \n                                                            }"
    }],
    staticClass: "fa fa-info-circle fs-normal dark has-tooltip ml-2"
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.descriptionMore),
      expression: "form.descriptionMore"
    }],
    attrs: {
      "rows": "30",
      "placeholder": "e.g. Cancellations and changes accepted up to 48 hours before the event"
    },
    domProps: {
      "value": (_vm.form.descriptionMore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "descriptionMore", $event.target.value)
      }
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "panel shaded mt-0",
    class: {
      error: _vm.$v.form.location.$error
    }
  }, [_vm._m(1), _vm._v(" "), _c('label', {
    staticClass: "full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.location),
      expression: "form.location"
    }],
    attrs: {
      "type": "text",
      "placeholder": "e.g. Albufeira, Marina de Albufeira"
    },
    domProps: {
      "value": (_vm.form.location)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "location", $event.target.value)
      }, _vm.$v.form.location.$touch]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller normal mt-2"
  }, [_vm._v("Insert a location or starting point for this product.")])]), _vm._v(" "), (_vm.$v.form.location.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.location.required) ? _c('span', [_vm._v("Location is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Notes")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small dark mt-2 mb-3"
  }, [_vm._v("\n                                            This information will be displayed on the calendar and on new reservations page.\n                                        ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.internalNote),
      expression: "form.internalNote"
    }],
    domProps: {
      "value": (_vm.form.internalNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "internalNote", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Booking question")]), _vm._v(" "), _c('label', {
    staticClass: "full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bookingQuestion),
      expression: "form.bookingQuestion"
    }],
    attrs: {
      "type": "text",
      "placeholder": "e.g. Do you have the required fishing license?"
    },
    domProps: {
      "value": (_vm.form.bookingQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bookingQuestion", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller normal mt-2"
  }, [_vm._v("Use this if you want to add a question to the booking process.")])]), _vm._v(" "), _c('checkbox', {
    on: {
      "input": _vm.questionActiveChanged
    },
    model: {
      value: (_vm.form.bookingQuestionIsActive),
      callback: function($$v) {
        _vm.$set(_vm.form, "bookingQuestionIsActive", $$v)
      },
      expression: "form.bookingQuestionIsActive"
    }
  }, [_vm._v("\n                                            Is question active.\n                                        ")]), _vm._v(" "), _c('checkbox', {
    staticClass: "ml-2",
    attrs: {
      "disabled": !_vm.form.bookingQuestionIsActive
    },
    model: {
      value: (_vm.form.bookingQuestionIsMandatory),
      callback: function($$v) {
        _vm.$set(_vm.form, "bookingQuestionIsMandatory", $$v)
      },
      expression: "form.bookingQuestionIsMandatory"
    }
  }, [_vm._v("\n                                            Is question mandatory.\n                                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Visibility")]), _vm._v(" "), _c('checkbox', {
    on: {
      "input": _vm.visibilityChanged
    },
    model: {
      value: (_vm.form.hideOnCalendar),
      callback: function($$v) {
        _vm.$set(_vm.form, "hideOnCalendar", $$v)
      },
      expression: "form.hideOnCalendar"
    }
  }, [_vm._v("\n                                            Plan Product "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Plan Product means that will not show on the calendar'),
      expression: "'Plan Product means that will not show on the calendar'"
    }],
    staticClass: "fas fa-info-circle ml-1"
  })]), _vm._v(" "), _c('checkbox', {
    staticClass: "ml-2",
    attrs: {
      "disabled": _vm.form.hideOnCalendar == false
    },
    model: {
      value: (_vm.form.showOnCalendarWhenHadBookings),
      callback: function($$v) {
        _vm.$set(_vm.form, "showOnCalendarWhenHadBookings", $$v)
      },
      expression: "form.showOnCalendarWhenHadBookings"
    }
  }, [_vm._v("\n                                            Only show on calendar if event has bookings\n                                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Sellable status (based on the event start and end time)")]), _vm._v(" "), _c('p', {
    staticClass: "fs-small dark mb-2"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tHere you can choose if this product can be sellable after the event start time or until the end\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mb-1 align-items-center w-100"
  }, [_c('radio', {
    attrs: {
      "name": "isSellableTillEnd",
      "value": true
    },
    model: {
      value: (_vm.form.isSellableTillEnd),
      callback: function($$v) {
        _vm.$set(_vm.form, "isSellableTillEnd", $$v)
      },
      expression: "form.isSellableTillEnd"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tIt will be for sale until the end of the events\n\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex mb-3 align-items-center w-100"
  }, [_c('radio', {
    attrs: {
      "name": "isSellableTillEnd",
      "value": false
    },
    model: {
      value: (_vm.form.isSellableTillEnd),
      callback: function($$v) {
        _vm.$set(_vm.form, "isSellableTillEnd", $$v)
      },
      expression: "form.isSellableTillEnd"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tSales are closed at event start time\n\t\t\t\t\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Product status")]), _vm._v(" "), (_vm.hasActiveSchedules) ? _c('p', {
    staticClass: "fs-small dark mb-2"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tYou are not allowed to deactivate this product because it has active schedules\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex mb-3 align-items-center w-100"
  }, [_c('span', {
    staticClass: "fs-small bold mr-2"
  }, [_vm._v("Product is active:")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      },
      "disabled": _vm.hasActiveSchedules
    },
    model: {
      value: (_vm.form.active),
      callback: function($$v) {
        _vm.$set(_vm.form, "active", $$v)
      },
      expression: "form.active"
    }
  })], 1)]), _vm._v(" "), (_vm.getShowInvoiceOption) ? _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Primavera Settings")]), _vm._v(" "), _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                            Cost Center\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })])]) : _vm._e()])])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("Product categories"), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Location "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-44da5c37", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44da5c37"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductEdit.vue
// module id = 1606
// module chunks = 0